import { BrandModel, BrandmodelModel, FollowUpStatus, BranchModel, ReferenceModel } from '../../model/index';
import * as commonActions from '../actions/common.actions';
import * as _ from 'lodash';
import {createSelector} from '@ngrx/store';

export interface State {
    auth: any[],
    brandList: BrandModel[],
    brandModelList: BrandmodelModel[],
    followUpList: FollowUpStatus[],
    branchList: BranchModel[],
    referenceList: ReferenceModel[]
}

export const INIT_STATE: State = {
    auth: [],
    brandList: [],
    brandModelList: [],
    followUpList: [],
    branchList: [],
    referenceList: []
};

export function reducer(state: State = INIT_STATE, action: commonActions.All) {

    switch (action.type) {
        case commonActions.IS_AUTH_SUCCESS: {
            return Object.assign(
                {},
                state,
                { auth: action.payload }
            )
        }
        case commonActions.LOAD_ALL_BRAND_SUCCESS: {
            return Object.assign(
                {},
                state,
                { brandList: action.payload }
            )
        }
        case commonActions.LOAD_ALL_BRAND_MODEL_SUCCESS: {
            return Object.assign(
                {},
                state,
                { brandModelList: action.payload }
            )
        }
        case commonActions.LOAD_ALL_FOLLOWUP_STATUS_SUCCESS: {
            return Object.assign(
                {},
                state,
                { followUpList: action.payload }
            )
        }
        case commonActions.LOAD_ALL_BRANCH_SUCCESS: {
            return Object.assign(
                {},
                state,
                { branchList: action.payload }
            )
        }
        case commonActions.LOAD_ALL_REFERENCE_SUCCESS: {
            return Object.assign(
                {},
                state,
                { referenceList: action.payload }
            )
        }
        default: {
            return state;
        }
    }
}


// SELECTORS (all selectors must be pure functions)
export const getAuth = (state: State): any[] => state.auth;
export const getAllBrand = (state: State): BrandModel[] => state.brandList;
export const getAllBrandModel = (state: State): BrandmodelModel[] => state.brandModelList;
export const getAllFollowUpStatus = (state: State): FollowUpStatus[] => state.followUpList;
export const getAllBranch = (state: State): BranchModel[] => state.branchList;
export const getAllReference = (state: State): ReferenceModel[] => state.referenceList;



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/store/reducers/common.reducer.ts